import { OnboardingCompanyProfile } from '__generated__/GQL';

/**
 * Returns whether a legalForm describes an EI or an EIRL.
 */
const getIsEi = ({ legalForm }: Pick<OnboardingCompanyProfile, 'legalForm'>) =>
  ['EI', 'EIRL'].includes(legalForm);

export default getIsEi;
